import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { PostParseProvider } from "./contexts/PostParseContext";
import Layout from "./components/Layout";
import DealLayout from "./components/DealLayout";
import DealsListPage from "./pages/DealsListPage";
import DashboardPage from "./pages/DashboardPage";
import RentRollPage from "./pages/RentRollPage";
import CashFlowPage from "./pages/CashFlowPage";
import ReimbursementsPage from "./pages/ReimbursementsPage";
import ScenariosPage from "./pages/ScenariosPage";
import DocumentsPage from "./pages/DocumentsPage";
import OperatingStatementPage from "./pages/OperatingStatementPage";
import AdminPage from "./pages/AdminPage";
import AuditPage from "./pages/AuditPage";
import ParseInspectorPage from "./pages/ParseInspectorPage";
import MarketLeasingPage from "./pages/MarketLeasingPage";
import PropertySettingsPage from "./pages/PropertySettingsPage";
import ActivityPage from "./pages/ActivityPage";
import ExpensesPage from "./pages/ExpensesPage";
import AssumptionsPage from "./pages/AssumptionsPage";
import AccessRequestsPage from "./pages/AccessRequestsPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import LandingPage from "./pages/LandingPage";
import CompsPage from "./pages/CompsPage";
import SourceDataPage from "./pages/SourceDataPage";
import ExportsPage from "./pages/ExportsPage";
import VerifyPage from "./pages/VerifyPage";
import RulesPage from "./pages/admin/RulesPage";
import AuditTrailPage from "./pages/AuditTrailPage";
import ProtectedRoute from "./components/ProtectedRoute";
import ErrorBoundary from "./components/ErrorBoundary";

export default function App() {
  return (
    <ErrorBoundary>
    <AuthProvider>
      <BrowserRouter>
      <PostParseProvider>
        <Routes>
          <Route path="/welcome" element={<LandingPage />} />
          <Route path="/sign-in/*" element={<SignInPage />} />
          <Route path="/request-access/*" element={<SignUpPage />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route index element={<DealsListPage />} />
              <Route path="deals" element={<DealsListPage />} />
              <Route path="comps" element={<CompsPage />} />
              <Route path="admin" element={<AccessRequestsPage />} />
              <Route path="admin/rules" element={<RulesPage />} />
              <Route path="deals/:dealId" element={<DealLayout />}>
                <Route index element={<DashboardPage />} />
                <Route path="rent-roll" element={<RentRollPage />} />
                <Route path="operating-statement" element={<OperatingStatementPage />} />
                <Route path="expenses" element={<ExpensesPage />} />
                <Route path="assumptions" element={<AssumptionsPage />} />
                <Route path="cash-flow" element={<CashFlowPage />} />
                <Route path="reimbursements" element={<ReimbursementsPage />} />
                <Route path="market-leasing" element={<MarketLeasingPage />} />
                <Route path="scenarios" element={<ScenariosPage />} />
                <Route path="verify" element={<VerifyPage />} />
                <Route path="documents" element={<DocumentsPage />} />
                <Route path="exports" element={<ExportsPage />} />
                <Route path="audit" element={<AuditPage />} />
                <Route path="audit-trail" element={<AuditTrailPage />} />
                <Route path="activity" element={<ActivityPage />} />
                <Route path="settings" element={<PropertySettingsPage />} />
                <Route path="source-data" element={<SourceDataPage />} />
                <Route path="parse-inspector" element={<ParseInspectorPage />} />
                <Route path="admin" element={<AdminPage />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </PostParseProvider>
      </BrowserRouter>
    </AuthProvider>
    </ErrorBoundary>
  );
}
